<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Item">
        <template slot="button">
          <button-add v-if="cP(62)" :to="{name: 'items-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/items" :fields="fields">
            <template v-slot:5="{item}">
              <div class="float-none">
                <button-link v-if="cP(63)" size="sm" :to="{name:'items-edit',params:{id: item[6]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(64)" @ondelete="deleteRow" :id="item[6]" :name="`${item[0]} (${item[1]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Kode'},
        1:{sortable: true, searchable: true, label:'Nama Item'},
        2:{sortable: true, searchable: true, label:'Alias'},
        3:{sortable: true, searchable: true, label:'Kategori'},
        4:{sortable: true, searchable: true, label:'Pemasok Default'},
        5:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('items/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>